import LayoutPage from "layouts/LayoutPage";
import ReplicaItemList from "./ReplicaItemList";
import SectionHeading from "components/SectionHeading";
import background from "assets/background/room-of-requirement.jpg";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ReplicaItems = () => {
  return (
    <LayoutPage background={background}>
      <Wrapper>
        <SectionHeading
          title="The Room of Hidden Things"
          subtitle="Prop Replicas, Grade-B, DIY, Prototypes"
        />

        <ReplicaItemList />
      </Wrapper>
    </LayoutPage>
  );
};

export default ReplicaItems;
